// Lodash
import _property from 'lodash/property';
import _some from 'lodash/some';

// Helpers
import { getLeafColumns } from './inputTable.nestedColumns';
export var areColumnsNested = function areColumnsNested(columns) {
  return _some(columns, _property('children'));
};
export var createColumns = function createColumns(columns) {
  var isNestedColumnStructure = areColumnsNested(columns);
  if (!isNestedColumnStructure) {
    return columns;
  }
  return getLeafColumns(columns);
};
export var getColumnId = _property('id');